export default () => {
  return (
    <div className="footer">
    </div>
  );
};
